<template>
  <div class="content-devx">
    <f7-block-title>
      <span>{{ `${$t('LeftPanel_subtitle_irrigation')}` }}</span>
    </f7-block-title>
    <div style="padding-top: 100px">
      <DxDataGrid
        :data-source="listIrrigation"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="false"
        :column-auto-width="true"
        :row-alternation-enabled="false"
        :word-wrap-enabled="true"
      >
        <DxSelection
          mode="single"
        />
        <DxExport
          :enabled="true"
          :texts="{exportAll: 'Exportar',}"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :show-info="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxSearchPanel
          text=""
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxColumnFixing :enabled="true" />
        <DxColumn
          data-field="name"
          :caption="$t('dataBaseIrrigation.column_name')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="simple_drip_distance"
          :caption="$t('dataBaseIrrigation.column_dripRate')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="simple_line_distance"
          :caption="$t('dataBaseIrrigation.column_simple_line')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="distanceLaterals"
          :caption="$t('dataBaseIrrigation.column_distance_laterals')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="pair_line_distance"
          :caption="$t('dataBaseIrrigation.column_doubleLines')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="pair_distance"
          :caption="$t('dataBaseIrrigation.column_distance_pairs')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="dostanceWithinPairs"
          :caption="$t('dataBaseIrrigation.column_distance_within_pairs')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="lateralsDouble"
          :caption="$t('dataBaseIrrigation.column_distance_lateralsDoubles')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { mapState } from 'vuex';

export default {
  name: 'IrrigationOpenAir',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
  },
  props: {
    listIrrigation: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
  },
  methods: {
    onChangeProvince() {

    },
    onChangeManure() {

    },
  },
};
</script>
  <style
    lang="scss"
    scoped
  >
    .boton-greenHouse {
    background: #FF7F26;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .boton-openAir {
    background: #51A411;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
    }
    .content-checkbox {
    padding-top: 50px;
    padding-left: 40px;
    }
    .content-devx {
        height: 500px !important;
    }
  </style>
